import script from "./AllCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./AllCourses.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__